import axios from 'axios';
export const getPublicLearningRouteCertificates = async (root, certificate, learningRoute) => axios
    .get(`${root}/legacy/learning-routes/${certificate}/${learningRoute}`)
    .then((output) => output.data)
    .catch(async (err) => (err.response?.status === 404 ? undefined : Promise.reject(err)));
//# sourceMappingURL=learning-routes.js.map